export { toOrdersReportScope as toItemsReportFilter } from './SkuOrderReports.filters';

export const UNCATEGORIZED_KEY = '__uncategorized__';

const SUGGESTIONS_LIMIT = 8;

export const normalizeSearchTerm = value => (value || '').trim().toLowerCase();

export function collectFilterOptions(items) {
  const menus = new Set();
  const categories = new Set();
  let hasUncategorized = false;
  items.forEach(item =>
    item.venueItems.forEach(venueItem => {
      venueItem.menus.forEach(menu => menus.add(menu));
      venueItem.categories.forEach(category => categories.add(category));
      if (!venueItem.categories.length) hasUncategorized = true;
    })
  );
  const collator = new Intl.Collator();
  return {
    menus: [...menus].sort(collator.compare),
    categories: [...categories].sort(collator.compare),
    hasUncategorized,
  };
}

const venueItemMatchesCategories = (venueItem, selectedCategories) =>
  venueItem.categories.some(category => selectedCategories.includes(category)) ||
  (!venueItem.categories.length && selectedCategories.includes(UNCATEGORIZED_KEY));

const itemMatchesSearch = (item, query) =>
  normalizeSearchTerm(item.name).includes(query) ||
  item.venueItems.some(venueItem => normalizeSearchTerm(venueItem.name).includes(query));

export function filterItems(items, { categories = [], menus = [], search = '' } = {}) {
  const query = normalizeSearchTerm(search);
  return items.filter(item => {
    if (categories.length && !item.venueItems.some(venueItem => venueItemMatchesCategories(venueItem, categories))) {
      return false;
    }
    if (menus.length && !item.venueItems.some(venueItem => venueItem.menus.some(menu => menus.includes(menu)))) {
      return false;
    }
    return !query || itemMatchesSearch(item, query);
  });
}

export function buildSearchSuggestions(items, search) {
  const query = normalizeSearchTerm(search);
  if (!query) return [];
  const matches = items.filter(item => itemMatchesSearch(item, query)).map(item => item.name);
  return [...new Set(matches)].slice(0, SUGGESTIONS_LIMIT);
}
